import { render, staticRenderFns } from "./insurance-detail-item.vue?vue&type=template&id=3943ff5c&"
import script from "./insurance-detail-item.vue?vue&type=script&lang=js&"
export * from "./insurance-detail-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports